// Clear User
import ClearUser from "@views/admin/ClearUser";
// Data
import AdminData from "@views/admin/data/AdminData";
import AdminDataHeader from "@views/admin/data/AdminDataHeader";
//partner
import PartnersHeader from "@views/admin/partner/components/PartnersHeader";
import Partners from "@views/admin/partner/Partners";

// Establishments
import EstablishmentsHeader from "@views/admin/establishments/components/EstablishmentsHeader";
import Establishments from "@views/admin/establishments/Establishments";
import MonitorHeader from "@views/admin/monitor/components/MonitorHeader";
// Devices
import Monitor from "@views/admin/monitor/Monitor";
// Monitoring
import Monitoring from "@views/admin/monitoring/Monitoring";
import MonitoringHeader from "@views/admin/monitoring/MonitoringHeader";
import OverviewHeader from "@views/admin/overview/components/OverviewHeader";
// Overview
import Overview from "@views/admin/overview/Overview";
import TagHeader from "@views/admin/tag/components/TagHeader";
// Tag
import LeadsAccessHeader from "@components/modules/leads/access/header/LeadsAccessHeader";
import Tag from "@views/admin/tag/Tag";
// Leads
import LeadsAccess from "@views/leads/access/LeadsAccess";
import UsageTermsHeader from "@views/usage-terms/components/UsageTermsHeader";
// Usage Terms
import UsageTerms from "@views/usage-terms/UsageTerms";
import UsageTermsCreate from "@views/usage-terms/UsageTermsCreate";
import UsageTermsEdit from "@views/usage-terms/UsageTermsEdit";
import Users from "@views/users/Users";
import UsersHeader from "@views/users/components/UsersHeader";
import { redirectUtils } from "../../util/redirect/redirectUtils";

export default [
    {
        name: "CLEAR_USER",
        path: "/admin",
        component: ClearUser,
        meta: {
            requiresAdmin: true
        }
    },

    // {
    //     name: "ADMIN_ADVERTISERS",
    //     path: "/admin/anunciantes",
    //     components: {
    //         default: Advertisers,
    //         header: AdvertisersHeader
    //     },
    //     meta: {
    //         requiresAdmin: true
    //     }
    // },

    {
        name: "ADMIN_ESTABLISHMENTS",
        path: "/admin/estabelecimentos",
        components: {
            default: Establishments,
            header: EstablishmentsHeader
        },
        meta: {
            requiresAdmin: true
        },
        beforeEnter: () => {
            location.assign(redirectUtils.mountUrl('/new/admin/estabelecimentos'))
        }
    },

    {
        name: "ADMIN_OVERVIEW",
        path: "/admin/visao-geral",
        components: {
            default: Overview,
            header: OverviewHeader
        },
        meta: {
            requiresAdmin: true
        }
    },
    {
        name: "ADMIN_PARTNER",
        path: "/admin/parceiros",
        components: {
            default: Partners,
            header: PartnersHeader
        },
        meta: {
            requiresAdmin: true
        },
        beforeEnter: () => {
            location.assign(redirectUtils.mountUrl('/new/admin/parceiros'))
        }
    },

    {
        name: "ADMIN_CADASTROS",
        path: "/admin/cadastros",
        components: {
            default: LeadsAccess,
            header: LeadsAccessHeader
        },
        meta: {
            requiresAdmin: true
        }
    },

    {
        name: "ADMIN_MONITOR",
        path: "/admin/monitor",
        components: {
            default: Monitor,
            header: MonitorHeader
        },
        meta: {
            requiresAdmin: true
        }
    },

    {
        name: "ADMIN_DATA",
        path: "/admin/dados",
        components: {
            default: AdminData,
            header: AdminDataHeader
        },
        meta: {
            requiresAdmin: true
        },
        beforeEnter: () => {
            location.assign(redirectUtils.mountUrl('/new/admin/dados'))
        }
    },

    // {
    //     name: "ADMIN_DEVICES",
    //     path: "/admin/locais",
    //     components: {
    //         default: Devices,
    //         header: DevicesHeader
    //     },
    //     meta: {
    //         requiresAdmin: true
    //     }
    // },

    {
        name: "ADMIN_TAG",
        path: "/admin/tag",
        components: {
            default: Tag,
            header: TagHeader
        },
        meta: {
            requiresAdmin: true
        }
    },

    {
        name: "ADMIN_MONITORING",
        path: "/admin/monitoramento",
        components: {
            default: Monitoring,
            header: MonitoringHeader
        },
        meta: { requiresAdmin: true }
    },

    {
        name: "UsageTerms",
        path: "/admin/termos-de-uso",
        components: {
            default: UsageTerms,
            header: UsageTermsHeader
        },
        meta: { requiresAdmin: true },
        beforeEnter: () => {
            location.assign(redirectUtils.mountUrl('/new/admin/termos-de-uso'))
        }
    },

    {
        name: "UsageTerms",
        path: "/admin/termos-de-uso/editar/:usageTermId",
        components: {
            default: UsageTermsEdit
        },
        meta: { requiresAdmin: true },
        beforeEnter: () => {
            location.assign(redirectUtils.mountUrl('/new/admin/termos-de-uso'))
        }
    },

    {
        name: "UsageTermsCreate",
        path: "/admin/termos-de-uso/cadastrar",
        components: {
            default: UsageTermsCreate
        },
        meta: { requiresAdmin: true },
        beforeEnter: () => {
            location.assign(redirectUtils.mountUrl('/new/admin/termos-de-uso'))
        }
    },

    {
        name: "ADMIN_USERS",
        path: "/admin/usuarios",
        components: {
            default: Users,
            header: UsersHeader
        },
        meta: {
            requiresAdmin: true
        },
        beforeEnter: () => {
            location.assign(redirectUtils.mountUrl('/new/admin/usuarios'))
        }
    },
];
